export const END_DAY_EVENT_TYPE = 'END_DAY';

export const FIXED_TRANSFER_TYPE = 'FIXED';
export const CONTINUES_TRANSFER_TYPE = 'CONTINUES';
export const KEEP_SAME_TRANSFER_TYPE = 'KEEP_SAME';
export const TO_CONTINUES_TRANSFER_TYPE = 'TO_CONTINUES';

export const FIXED_SESSION_TYPE = 'FIXED';
